export default __webpack_public_path__ + "static/media/studentRealCase2.10da119f.png";